import React, { useState } from 'react'
import TopBar from '../../components/admin/TopBar'
import CreateMilestoneModal from '../../components/admin/CreateMilestoneModal'
import EditMilestoneModal from '../../components/admin/EditMilestoneModal'
import axios from 'axios'
import Swal from 'sweetalert2'
import DataTable from 'react-data-table-component'
import useFetch from '../../hooks/useFetch'

import { useAuth } from '../../context/AuthContext';
import { useParams } from 'react-router-dom';
import { ucwords } from '../../utils/Ucwords';
const MilestonePage = () => {
    const API_URL = process.env.REACT_APP_API_URL;

    const { id } = useParams();
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedMilestone, setSelectedMilestone] = useState(null);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const { user } = useAuth();

    const openCreateModal = () => setIsCreateModalOpen(true);
    const closeCreateModal = () => setIsCreateModalOpen(false);

    const openEditModal = (milestone) => {
        setSelectedMilestone(milestone);
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setSelectedMilestone(null);
        setIsEditModalOpen(false);
    };

    const handleEdit = (milestone) => {
        openEditModal(milestone);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });
    
        if (result.isConfirmed) {
            try {
                const token = localStorage.getItem('token'); // Retrieve token from local storage
                const deleteMilestone = await axios.delete(`${API_URL}/milestones/${id}`, {
                    headers: {
                      'Authorization': `Bearer ${token}` // Attach token to headers
                    }
                });
                const { message } = deleteMilestone.data;
                // Show success message
                Swal.fire({
                    title: 'Deleted!',
                    text: message,
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 3000
                });
            } catch (error) {
                console.error('Error deleting milestone:', error);
                Swal.fire(
                    'Error!',
                    'There was an error deleting the milestone.',
                    'error'
                );
            }
        }
    };

    const { data } = useFetch(`${API_URL}/milestones/${id}`);
    const { data: milestones, refetch  } = useFetch(`${API_URL}/milestone/${id}`);

    // Filter milestones based on searchTerm
    const filterMilestone = milestones.filter(milestone => 
        milestone.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const columns = [
        {
            name: 'Name',
            selector: row => `${ucwords(row.name)}`,
            sortable: true,
        },
        {
            name: 'Percentage',
            selector: row => `${row.percentage}%`,
            sortable: true,
        },
        ...((user.role_name === 'Head Admin' || user.role_name === 'Senior Admin') ? [
            {
                name: 'Action',
                cell: row => (
                    <div className="flex space-x-2">
                        <button
                            className="text-blue-500 hover:text-blue-700"
                            onClick={() => handleEdit(row)}
                        >
                            <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                        <button
                            className="text-red-500 hover:text-red-700"
                            onClick={() => handleDelete(row.id)}
                        >
                            <i className="fa-solid fa-trash"></i>
                        </button>
                    </div>
                )
            }
        ] : [])
    ];

    const customStyles = {
        headCells: { style: { fontWeight: 'bold', fontSize: '14px' } },
    };

    return (
        <>
            <TopBar />
            <CreateMilestoneModal 
                isOpen={isCreateModalOpen} 
                onSuccess={refetch} 
                onClose={closeCreateModal} 
                serviceId={id} 
            /> 

            <EditMilestoneModal 
                isOpen={isEditModalOpen} 
                onClose={closeEditModal} 
                onSuccess={refetch} 
                milestone={selectedMilestone} 
            />

            <div className="p-2 mt-16">
                <div className="flex flex-col">
                    <div className="flex pb-2 justify-between border-b-2">
                        <div className="font-semibold text-xl">
                            <label>{data ? data.service : 'Service not found'}</label>
                        </div>
                        {(user.role_name === 'Head Admin' || user.role_name === 'Senior Admin') && (
                            <button 
                                className="text-white bg-[var(--customRed)] hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                onClick={openCreateModal}
                            >
                                Create Milestone
                            </button>
                        )}
                    </div>
                </div>
                <div className='mt-3'>
                    <div className='flex justify-end gap-3'>
                        <label htmlFor='search' className='mt-1.5'>Search:</label>
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="form-input p-1.5 block border-gray-300 rounded-lg shadow-sm focus:ring-green-800 focus:border-green-800 mb-1"
                        />
                    </div>
                    <DataTable
                        columns={columns}
                        data={filterMilestone}
                        pagination
                        responsive
                        highlightOnHover
                        pointerOnHover
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        customStyles={customStyles}
                    />
                </div>
            </div>
        </>
    );
};

export default MilestonePage;
